import axios from 'axios'

const API_URL = process.env.REACT_APP_API_URL ? `${process.env.REACT_APP_API_URL}/Notifications` : undefined

export type UserNotification = {
    id: number
    projectId: number
    projectName: string
    message: string
    recordUrl: string
    createdAt: string
    isRead: boolean
    readAt?: string | null
}

const getApiUrl = () => {
    if (!API_URL) {
        throw new Error('REACT_APP_API_URL is not configured.')
    }
    return API_URL
}

export const listNotifications = async (): Promise<UserNotification[]> => {
    const { data } = await axios.get<UserNotification[]>(getApiUrl())
    return data
}

export const getUnreadNotificationCount = async (): Promise<number> => {
    const { data } = await axios.get<number>(`${getApiUrl()}/unread-count`)
    return data;
}

export const markNotificationsRead = async (ids: number[]): Promise<void> => {
    await axios.post(`${getApiUrl()}/mark-read`, { ids })
}